import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { ProseMirrorJSONSchema } from './ProseMirrorJSONSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const TableWidgetStaticSchema = BaseWidgetSchema(WidgetType.Table).extend({
  /**
   * ProseMirror JSON
   */
  caption: ProseMirrorJSONSchema,
  columnOrder: z.array(z.string()),
  columnWidths: z.record(z.string(), z.number()),
  /**
   * Map of contentId -> ProseMirror JSON (cell content)
   */
  contentById: z.record(z.string(), ProseMirrorJSONSchema),
  rowOrder: z.array(z.string()),
  style: z.record(z.unknown())
});

export type TableWidgetStaticSchemaType = z.infer<typeof TableWidgetStaticSchema>;
